import React, { useContext } from "react";
import styles from "./BestSolution.module.scss";
import Button from "../../Common/Button/Button";
import AppContext from "../../../context/AppContext";
function BestSolution() {
  const { contactForm, setContactForm }: any = useContext(AppContext);

  return (
    <div className={styles["solution-wrapper"]}>
      {/* <div className={styles["solution-wrapper-header"]}>
        <p>Not sure which solution best suits your needs?</p>
      </div>
      <div
        className={styles["solution-wrapper-button"]}
        onClick={() => setContactForm(true)}
      >
        <Button text="Let's Talk" />
      </div> */}
      <div className={styles["solution-content"]}>
        <p>Gather enough data to completely retrain Data Models.</p>
      </div>
    </div>
  );
}

export default BestSolution;
